// store.js

import { configureStore } from "@reduxjs/toolkit";
import UserInfoReducer from './user/reducer'
import JobInfoReducer from './job/reducer'
import PointingsInfoReducer from './pointings/reducer'
import changeState from './StateStore/reducer'
const store = configureStore({
  reducer: {
    UserInfoReducer: UserInfoReducer,
    JobInfoReducer:JobInfoReducer,
    PointingsInfoReducer:PointingsInfoReducer,
    changeState:changeState
  },
});

export default store;
